import React from "react";

const handleTransitOpenPayments = (props) => {
  const options = [
    {
      text: 'What are Transit Open Payments?',
      handler: props.actionProvider.handleTransit1,
      id: 1,
    },
    {
      text: 'Where can I use my debit card for Transit Open Payments?',
      handler: props.actionProvider.handleTransit2,
      id: 2
    },
    {
      text: 'Are Transit Open Payments going to be available with all transit authorities in all cities in Canada?',
      handler: props.actionProvider.handleTransit3,
      id: 3
    },
    {
      text: 'If I currently have a transit authority payment card (such as a PRESTO card), will this payment method replace transit fare cards?',
      handler: props.actionProvider.handleTransit4,
      id: 4
    },
    {
      text: 'How will I be charged when using INTERAC Debit on GO Transit and UP Express?',
      handler: props.actionProvider.handleTransit5,
      id: 5
    },
    {
      text: 'Who do I contact if I have a problem with a payment made using INTERAC Debit on a fare reader?',
      handler: props.actionProvider.handleTransit6,
      id: 6
    },
    {
      text: 'How do I pay my fare using INTERAC Debit at participating transit locations?',
      handler: props.actionProvider.handleTransit7,
      id: 7
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container transit-open-payments'>{optionsMarkup}</div>;
};

export default handleTransitOpenPayments;